import { NewsView, NewsListView, NewsDetailView } from '@/views';

const routes = {
  privatePaths: [
    {
      path: '/news',
      component: NewsView,
      children: [
        {
          path: '',
          component: NewsListView,
          name: 'NewsListView',
          props: ({ query }) => ({
            type: query.type || null,
            bussinessType: query.bussinessType || null,
          }),
        },
        {
          path: ':id',
          component: NewsDetailView,
          name: 'NewsDetailView',
          props: ({ params }) => ({
            id: params.id,
          }),
        },
      ],
    },
  ],
  publicPaths: [],
};

export default routes;
